module.exports = __webpack_public_path__ + "static/media/HockeyTouchArea.694140f9.png";